import { useCallback, useEffect, useState } from "react";
import { logError } from "../errors/index.js";
function useLocalStorage(key, initialValue) {
    const { value, setValueAndStore } = useStorage(window.localStorage, key, initialValue);
    return [
        value,
        setValueAndStore
    ];
}
function useSessionStorage(key, initialValue) {
    const { value, setValueAndStore } = useStorage(window.sessionStorage, key, initialValue);
    return [
        value,
        setValueAndStore
    ];
}
function useLocalStorageSynced(key, initialValue) {
    const { value, setValue, setValueAndStore } = useStorage(window.localStorage, key, initialValue);
    useEffect(()=>{
        const sync = (e)=>{
            if (e.key !== key || null === e.newValue) return;
            setValue(JSON.parse(e.newValue));
        };
        window.addEventListener('storage', sync);
        return ()=>{
            window.removeEventListener('storage', sync);
        };
    }, [
        key,
        setValue
    ]);
    return [
        value,
        setValueAndStore
    ];
}
function useStorage(storage, key, initialValue) {
    const { getItem, setItem } = accessStorage(storage, key);
    const [value, setValue] = useState(()=>{
        const storedValue = getItem();
        if (void 0 !== storedValue) return storedValue;
        setItem(initialValue);
        return initialValue;
    });
    const setValueAndStore = useCallback((val)=>{
        setValue(val);
        trySetStorageItem(storage, key, val);
    }, [
        setValue,
        storage,
        key
    ]);
    return {
        value,
        setValue,
        setValueAndStore
    };
}
const accessStorage = (storage, key)=>{
    const getItem = ()=>{
        try {
            const jsonString = storage.getItem(key);
            if (null !== jsonString && 'undefined' !== jsonString) return JSON.parse(jsonString);
        } catch (e) {
            console.error(e);
        }
    };
    const setItem = (value)=>{
        trySetStorageItem(storage, key, value);
    };
    return {
        getItem,
        setItem
    };
};
const trySetStorageItem = (storage, key, value)=>{
    try {
        storage.setItem(key, JSON.stringify(value));
    } catch (e) {
        const storageSizes = getAllStorageKeysAndSizes();
        logError(e, {
            contexts: {
                storage: {
                    storageSizes
                }
            }
        });
    }
};
const getStorageKeysAndSizes = (storage)=>{
    const result = {};
    const storageKeys = Object.keys(storage);
    try {
        storageKeys.forEach((key)=>{
            const value = storage.getItem(key);
            const size = 2 * (value ?? '').length;
            result[key] = size;
        });
    } catch (e) {
        logError(e);
    }
    const sortedEntries = Object.entries(result).sort(([, sizeA], [, sizeB])=>sizeB - sizeA).slice(0, 3);
    return Object.fromEntries(sortedEntries);
};
const getAllStorageKeysAndSizes = ()=>({
        localStorage: getStorageKeysAndSizes(window.localStorage),
        sessionStorage: getStorageKeysAndSizes(window.sessionStorage)
    });
export { accessStorage, getAllStorageKeysAndSizes, getStorageKeysAndSizes, trySetStorageItem, useLocalStorage, useLocalStorageSynced, useSessionStorage };

//# sourceMappingURL=browser-storage.js.map